import api from './api';

const enc = (s) => encodeURIComponent(s);

const kySoService = {
  // ── Chữ ký ──────────────────────────────────────────────────────────────

  /** loaiChuKy: 'FULL' | 'NHAY' | undefined (undefined = tất cả) */
  getAllChuKy: async (loaiChuKy) => {
    const res = await api.get('/api/ky-so/chu-ky', { params: loaiChuKy ? { loaiChuKy } : {} });
    return res.data.data;
  },

  uploadChuKy: async (file, tenNguoiKy, chucVu, laMacDinh = false, loaiChuKy = 'FULL') => {
    const form = new FormData();
    form.append('file', file);
    form.append('tenNguoiKy', tenNguoiKy);
    if (chucVu) form.append('chucVu', chucVu);
    form.append('laMacDinh', laMacDinh);
    form.append('loaiChuKy', loaiChuKy);
    const res = await api.post('/api/ky-so/chu-ky', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.data;
  },

  deleteChuKy: async (id) => {
    await api.delete(`/api/ky-so/chu-ky/${id}`);
  },

  // ── Con dấu ──────────────────────────────────────────────────────────────

  /** Toàn bộ con dấu (yêu cầu quyền QUAN_LY_CON_DAU) hoặc chỉ con dấu dùng được (nếu không có quyền quản lý) — backend tự quyết định. */
  getAllConDau: async () => {
    const res = await api.get('/api/ky-so/con-dau');
    return res.data.data;
  },

  uploadConDau: async (file, ten, laMacDinh = false, ownerUsername = null) => {
    const form = new FormData();
    form.append('file', file);
    form.append('ten', ten);
    form.append('laMacDinh', laMacDinh);
    if (ownerUsername) form.append('ownerUsername', ownerUsername);
    const res = await api.post('/api/ky-so/con-dau', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return res.data.data;
  },

  deleteConDau: async (id) => {
    await api.delete(`/api/ky-so/con-dau/${id}`);
  },

  // ── Preview ──────────────────────────────────────────────────────────────

  /**
   * Lấy ảnh preview (base64 PNG) từng trang của danh sách tham gia.
   * Luôn dùng POST để hỗ trợ colConfig, overrides, editZones.
   * @param {string} maHoatDong
   * @param {{ overrideRows?, overrideTieuDe?, overrideNgayStr?, colConfig? }} [body]
   */
  getPreview: async (maHoatDong, body = null) => {
    const res = await api.post(`/api/ky-so/preview/${enc(maHoatDong)}`, body || {});
    return res.data.data;
  },

  // ── Xuất PDF ──────────────────────────────────────────────────────────────

  /**
   * Xuất PDF danh sách tham gia có ký số và bảo mật.
   * @param {string} maHoatDong
   * @param {object} params - {
   *   loaiKy, chuKyBiThuId, tenNguoiKy,
   *   chuKyNguoiLapId, tenNguoiLap, chucVuNguoiLap, conDauId,
   *   posBiThu, posNguoiLap, posConDau   ← { x, y, width, height } pixel trên ảnh preview
   * }
   */
  xuatPDF: async (maHoatDong, params) => {
    const body = {
      loaiKy:           params.loaiKy          || 'BÍ THƯ',
      chuKyBiThuId:     params.chuKyBiThuId    ?? null,
      tenNguoiKy:       params.tenNguoiKy       || '',
      chuKyNguoiLapId:  params.chuKyNguoiLapId ?? null,
      tenNguoiLap:      params.tenNguoiLap      || '',
      chucVuNguoiLap:   params.chucVuNguoiLap  ?? null,
      conDauId:         params.conDauId         ?? null,
      posBiThu:         params.posBiThu         ?? null,
      posNguoiLap:      params.posNguoiLap      ?? null,
      posConDau:        params.posConDau         ?? null,
      customMaSvList:   params.customMaSvList   ?? null,
      overrideRows:     params.overrideRows     ?? null,
      overrideTieuDe:   params.overrideTieuDe   ?? null,
      overrideNgayStr:  params.overrideNgayStr  ?? null,
      colConfig:        params.colConfig        ?? null,
      orgLabel:         params.orgLabel         ?? null,
      formatConfig:     params.formatConfig     ?? null,
      apDungGiapLai:    params.apDungGiapLai    ?? false,
      chuKyNhayId:      params.chuKyNhayId       ?? null,
      khoaFilePdf:      params.khoaFilePdf       ?? false,
    };

    const res = await api.post(
      `/api/ky-so/xuat-pdf/${enc(maHoatDong)}`,
      body,
      { responseType: 'blob' }
    );

    // Tạo link download
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `danh_sach_tham_gia_${maHoatDong}.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  // ── Lịch sử ký số ────────────────────────────────────────────────────────

  getLichSu: async (page = 0, size = 20) => {
    const res = await api.get(`/api/ky-so/lich-su?page=${page}&size=${size}`);
    return res.data.data; // Page<KySoLichSu>
  },

  getLichSuByHoatDong: async (maHoatDong) => {
    const res = await api.get(`/api/ky-so/lich-su/${enc(maHoatDong)}`);
    return res.data.data;
  },
};

export default kySoService;
